import { Routes } from '@angular/router';
import { SCOPES } from 'src/app/app.constants';
import { ScopeGuard } from '../auth/services/scope.guard';

export const EVENT_ROUTES: Routes = [
  {
    path: ':id', loadComponent: () => import('./components/event-view/event-view.component').then(m => m.EventViewComponent), canActivate: [ScopeGuard], data: { scopes: [SCOPES.events.read] }, children: [
      { path: 'history', loadComponent: () => import('./components/event-view/history/event-history.component').then(m => m.EventHistoryComponent), canActivate: [ScopeGuard], data: { scopes: [SCOPES.events.revise] } },
      { path: 'overview', loadComponent: () => import('./components/event-view/overview/event-overview.component').then(m => m.EventOverviewComponent) },
      { path: '', redirectTo: 'overview', pathMatch: 'full' }
    ]
  },
  { path: '', loadComponent: () => import('./components/events/events.component').then(m => m.EventsComponent), canActivate: [ScopeGuard], data: { scopes: [SCOPES.events.read] } }
];
